class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.pendingSnapshot = null;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open({ pending = false } = {}) {
  this.notification.classList.add(
    'animate',
    'active'
  );

  this.notification.addEventListener(
    'transitionend',
    () => {
      this.notification.focus();
      trapFocus(this.notification);
    },
    {
      once: true
    }
  );

  /*
    Mobile browsers can dispatch the final click/tap shortly
    after the notification becomes active. Waiting briefly
    prevents that same tap from immediately closing it.
  */
  window.clearTimeout(this.bodyClickTimer);

  const outsideClickDelay =
    window.matchMedia('(max-width: 749px)').matches
      ? 700
      : 0;

  this.bodyClickTimer = window.setTimeout(() => {
    if (
      this.notification.classList.contains('active')
    ) {
      document.body.addEventListener(
        'click',
        this.onBodyClick
      );
    }
  }, outsideClickDelay);

  if (
    !pending &&
    typeof this.dispatchCartViewEvent === 'function'
  ) {
    this.dispatchCartViewEvent();
  }
}

  openPending() {
    const productContainer = this.querySelector('#cart-notification-product');
    const heading = this.notification.querySelector('.cart-notification__heading span');

    if (!productContainer || !heading || this.notification.classList.contains('is-pending')) return;

    this.pendingSnapshot = {
      productHTML: productContainer.innerHTML,
      headingText: heading.textContent,
    };

    heading.textContent = 'Adding to Kanha Ji’s Seva Basket…';
    productContainer.innerHTML = `
      <div class="om-cart-notification-pending" role="status" aria-live="polite">
        <span class="om-cart-notification-pending__spinner" aria-hidden="true"></span>
        <span>Confirming your selected item…</span>
      </div>
    `;

    this.notification.classList.add('is-pending');
    this.open({ pending: true });
  }

  cancelPending() {
    if (!this.pendingSnapshot) return;

    const productContainer = this.querySelector('#cart-notification-product');
    const heading = this.notification.querySelector('.cart-notification__heading span');

    if (productContainer) productContainer.innerHTML = this.pendingSnapshot.productHTML;
    if (heading) heading.textContent = this.pendingSnapshot.headingText;

    this.pendingSnapshot = null;
    this.notification.classList.remove('is-pending');
    this.close();

    this.dispatchEvent(
      new CustomEvent('om:cart-add-pending-cancel', {
        bubbles: true,
      })
    );
  }

  completePending() {
    const heading = this.notification.querySelector('.cart-notification__heading span');

    if (heading) heading.textContent = 'Added to Kanha Ji’s Seva Basket';

    this.pendingSnapshot = null;
    this.notification.classList.remove('is-pending');
  }

  close() {
  window.clearTimeout(this.bodyClickTimer);

  this.notification.classList.remove('active');

  document.body.removeEventListener(
    'click',
    this.onBodyClick
  );

  removeTrapFocus(this.activeElement);
}

  renderContents(parsedState) {
    const notificationWasOpen = this.notification.classList.contains('active');

    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.completePending();

    /*
     * Always pass the confirmed state through open(). OM Poshak's cart
     * experience uses this single hand-off to turn an existing pending view
     * into one confirmed notification without replaying its entrance.
     */
    this.open({
      confirmed: true,
      reuseOpen: notificationWasOpen,
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
